var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('el-date-picker',{staticStyle:{"width":"300px"},attrs:{"type":"monthrange","range-separator":"至","start-placeholder":"开始月份","end-placeholder":"结束月份","picker-options":_vm.pickerOptions},on:{"change":_vm.handleSelectInputClick},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-904ad198","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/statement/components/reportMonthCopy.vue
// module id = null
// module chunks = 